
import React, {FC} from 'react';
import PostCard from 'components/blog/PostCard';
import {usePopular} from 'components/blog/useBlogs/usePopular';
import {sampleSeed} from 'utils/sampleSeed';

import * as styles from './styles.module.scss';

export const Recs: FC<{seed: string}> = ({seed}) => {
	const populars = sampleSeed(seed, usePopular(), 3);
	return (
		<div className={styles.recs}>
			<div className={styles.recommendations}>
				Recommended articles
				<div className={styles.recList}>
					{populars.map((post) => (
						<PostCard {...post} key={post.slug} />
					))}
				</div>
			</div>
		</div>
	);
};
